import styled from "styled-components";

export const Icon = styled.img`
  width: 16px;
`;
